function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { showTostLoader } from '../../slices/customQueryHeaderSlice';
const options = ['Save As'];
export const StyledButtonSaveSplit = styled(ButtonGroup)`
  margin-right: 32px;
  &.MuiButton-root {
    margin: 0px 5px;
    border-radius: 5px;
    min-width: 82px !important;
    height: 32px !important;
    background: #393939 !important;
    border: none !important;
    border-radius: 2px !important;
    line-height: 15px !important;
    font-size: 13px !important;
    text-transform: none !important;
  }

  &.MuiButtonGroup-contained {
    box-shadow: none;
  }
`;
export const StyledButtonSaveSplit1 = styled(Button)`
  &.MuiButton-root {
    margin: 0px 1px 0px 0px;
    padding: 0px 16px !important;
    height: 32px !important;
    background: #393939 !important;
    border: none !important;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    line-height: 15px !important;
    font-size: 13px !important;
    color: white !important;
    text-transform: none !important;
  }
  &.Mui-disabled {
    opacity: 0.65;
  }
  &:hover {
    box-shadow: none !important;
    background-color: #8e8e8e !important;
  }
`;
export const StyledButtonSaveSplit2 = styled(Button)`
  &.MuiButton-root {
    padding: 0px 0px !important;
    height: 32px !important;
    background: #393939 !important;
    border: none !important;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    line-height: 15px !important;
    font-size: 13px !important;
    color: white !important;
    text-transform: none !important;
  }
  &.Mui-disabled {
    opacity: 0.65;
  }
  &:hover {
    box-shadow: none !important;
    background-color: #8e8e8e !important;
  }
`;
export const StyledGrow = styled(Grow)`
  && {
    transform-origin: ${props => props.placement === 'bottom' ? 'center top' : 'center bottom'};
  }
`;
export const StyledMenuList = styled(MenuList)`
  && {
    padding-top: 0px;
    padding-bottom: 0px;
  }
`;
export const StyledMenuItem = styled(MenuItem)`
  && {
    color: white;
    background-color: black !important;
    opacity: 0.65;
    font-size: 14px;
    width: 104px;
    margin-left: 0px;
  }
`;
export default function SaveSplitButton(props) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const dispatch = useDispatch();
  const {
    handleClick,
    handleSaveQuery,
    disabled,
    queryData
  } = props;
  const queryName = useSelector(state => state.queriesManager.queryName);
  const isBritSave = useSelector(state => state.customQueryHeader.isBritSave);

  const handleSaveClick = () => {
    if (queryName) {
      const values = {
        queryname: queryData.queryname,
        description: queryData.description
      };
      dispatch(showTostLoader(true));
      handleSaveQuery(values, 'Save');
    } else {
      handleClick('Save');
    }
  };

  const handleMenuItemClick = (event, index) => {
    handleClick(options[index]);
  };

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledButtonSaveSplit, {
    variant: "contained",
    ref: anchorRef,
    "aria-label": "split button"
  }, /*#__PURE__*/React.createElement(StyledButtonSaveSplit1, {
    disabled: isBritSave ? isBritSave : disabled,
    onClick: handleSaveClick
  }, "Save"), /*#__PURE__*/React.createElement(StyledButtonSaveSplit2, {
    size: "small",
    disabled: disabled,
    "aria-controls": open ? 'split-button-menu' : undefined,
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "select merge strategy",
    "aria-haspopup": "menu",
    onClick: handleToggle
  }, /*#__PURE__*/React.createElement(ExpandMoreIcon, null))), /*#__PURE__*/React.createElement(Popper, {
    open: open,
    anchorEl: anchorRef.current,
    role: undefined,
    transition: true,
    disablePortal: true
  }, ({
    TransitionProps,
    placement
  }) => /*#__PURE__*/React.createElement(StyledGrow, _extends({}, TransitionProps, {
    placement: placement
  }), /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: handleClose
  }, /*#__PURE__*/React.createElement(StyledMenuList, {
    id: "split-button-menu"
  }, options.map((option, index) => /*#__PURE__*/React.createElement(StyledMenuItem, {
    key: option,
    disabled: index === 0 && queryName === '',
    onClick: event => handleMenuItemClick(event, index)
  }, option))))))));
}